export const ADMIN_ACCESS_TOKEN_COOKIE = 'admin-jwt'
export const ADMIN_REFRESH_TOKEN_COOKIE = 'admin-refresh-jwt'
export const ADMIN_ID_TOKEN_COOKIE = 'admin-id-token'
export const ADMIN_SESSION_COOKIE = 'admin-session'
export const ADMIN_SESSION_COOKIE_VALUE = 'true'

export function isAdminSessionCookieValue(
  value: string | null | undefined
): boolean {
  return value === ADMIN_SESSION_COOKIE_VALUE
}
